import {
  Toast,
  InlineStack,
  Button,
  Modal,
  Text,
  Select,
  RadioButton,
  Page,
  FormLayout,
  Spinner,
  TextContainer,
  Card,
  Checkbox,
  Loading,
  ButtonGroup,
  Layout,
  TextField,
  Icon,
  Autocomplete,
  Banner,
  Popover,
  ActionList,
  InlineError,
  InlineGrid,
} from "@shopify/polaris";
import React from "react";
import { useState, useCallback, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { SectionCollapse } from "../../Components/SectionCollapse";
import axios from "../../Assets/Lib/axios";
import "react-bootstrap-accordion/dist/index.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import BannerPreview from "../../Components/PreviewLayoutComponents/BannerPreview";
import RichTextPreview from "../../Components/PreviewLayoutComponents/RichTextPreview";
import ImageWithTextPreview from "../../Components/PreviewLayoutComponents/ImageWithTextPreview";
import SelectCustom from "react-select";
import {
  ExportIcon,
  MobileIcon,
  SearchMinor,
  TextWithImageIcon,
  ThemeTemplateIcon,
  OutgoingIcon,
} from "@shopify/polaris-icons";
import moment from "moment";
import { adminRole } from "../../Helpers";
import parse from "html-react-parser";
import { AlertCircleIcon } from "@shopify/polaris-icons";
import ShopifyCollectionPreviewSlider from "../../Components/PreviewLayoutComponents/ShopifyCollectionPreviewSlider";
import { GallerySlider } from "../../Components/PreviewLayoutComponents/GallerySlider";
import ShopifyProductsPreview from "../../Components/PreviewLayoutComponents/ShopifyProductsPreview";
import {
  accessCloneVersion,
  accessPublishVersion,
  accessAddSections,
} from "../../Helpers";
import AsyncSelect from "react-select/async";
import { ListPreview } from "../../Components/PreviewLayoutComponents/ListPreview";
import VideoPreview from "../../Components/PreviewLayoutComponents/VideoPreview";
import { Switch } from "@material-ui/core";
import FormControlLabel from "@mui/material/FormControlLabel";
import SlidingPanel from "../../Components/SlidingPanel";
import { SectionCollapseOutside } from "../../Components/SectionCollapseOutside";

const Sections = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isCreatingVersion, setIsCreatingVersion] = useState(false);
  const [loadingSections, setLoadingSections] = useState(true);
  const [boolPreview, setBoolPreview] = useState(true);
  const [previewState, setPreviewState] = useState("nothing-preview");
  const [boolVersionChanged, setBoolVersionChanged] = useState(true);
  const [generalInstructionValue, setGeneralInstructionValue] = useState("");

  const [active, setActive] = useState(false);
  const handleChange = () => {
    setActive(!active);
    setSelected("");
    setCheckedImportSection(false);
    setSectionTypeError("");
    setOtherPagesSectionError("");
  };
  const [selectedOtherPagesSection, setSelectedOtherPagesSection] =
    useState("");
  const handleSelectChangeOtherPagesSection = (value) => {
    console.log(value);
    setSelectedOtherPagesSection(value);
    setOtherPagesSectionError("");
  };
  const [otherPagesSectionError, setOtherPagesSectionError] = useState("");
  const [optionsOtherPagesSections, setOptionsOtherPagesSections] = useState(
    []
  );
  const [selected, setSelected] = useState("");
  const handleSelectChange = (value) => {
    setSelected(value);
    setSectionTypeError("");
  };
  const [sectionTypeError, setSectionTypeError] = useState("");
  const [options, setOptions] = useState([]);
  const [ts, setTs] = useState("");

  const handleAddSection = () => {
    setActive(!active);
  };
  const handleSubmit = () => {
    if (!checkedImportSection) {
      if (
        selected === "" ||
        (selected === "shopify_collection" && shopifyCollection === "")
      ) {
        selected === "" && setSectionTypeError("Please choose a section type");
        selected === "shopify_collection" &&
          shopifyCollection === "" &&
          setShopifyError("This field is required");
      } else {
        setIsSaving(true);
        const form_data = new FormData();
        form_data.append("section_type", selected);
        form_data.append("is_active", 1);
        form_data.append("version_id", parseInt(selectedVersion.value));
        selected === "shopify_collection" &&
          form_data.append("collection_handle", shopifyCollection.value);
        selected === "shopify_collection" &&
          form_data.append("collection_id", shopifyCollection.id);
        // selected === "shopify_collections_list" &&
        //   form_data.append("handle", selectedOptions);
        // selected === "shopify_products_list" &&
        //   form_data.append("handle", selectedOptions);
        form_data.append("instructions", instructionValue);
        axios
          .post(`/pages/${id}/sections`, form_data)
          .then((res) => {
            setInstructionValue("");
            setSelected("");
            handleChangeModalAndRefresh();
            window.scrollTo(0, document.body.scrollHeight);
            setInputValueCollection("");
          })
          .catch((err) => console.log(""));
      }
    } else {
      if (selectedOtherPagesSection === "") {
        setOtherPagesSectionError("Please choose a section to import");
      } else {
        setIsSaving(true);
        const form_data = new FormData();
        form_data.append("section_id", selectedOtherPagesSection);
        form_data.append("is_active", 1);
        form_data.append("copy", valueImportType === "clone" ? 0 : 1);
        form_data.append("version_id", parseInt(selectedVersion.value));

        axios
          .post(`import/sections/${id}`, form_data)
          .then((res) => {
            setSelectedOtherPagesSection("");
            setCheckedImportSection(false);
            handleChangeModalAndRefresh();
            window.scrollTo(0, document.body.scrollHeight);
          })
          .catch((err) => console.log(""));
      }
    }
  };
  const handleSavingState = () => {
    setIsSaving(true);
  };
  const handleResetSavingState = () => {
    setIsSaving(false);
  };
  const handleChangeModalAndRefresh = () => {
    setActive(!active);
    setIsSaving(false);
    setTs(+new Date());
    setToastMessage("Section added succesfully");
    toggleActiveToast();
  };
  const handleSaveWithoutRefresh = () => {
    setIsSaving(false);
    setToastMessage("Changes have been saved successfully");
    toggleActiveToast();
  };
  const handleSaveAndRefresh = () => {
    setIsSaving(false);
    setTs(+new Date());
    setToastMessage("Changes have been saved successfully");
    toggleActiveToast();
  };

  const refDeleteSectionId = useRef(null);
  const handleShowDeleteModal = (sectionId) => {
    setIsOpeningSlider(false);
    refDeleteSectionId.current = sectionId;
    toggleActiveToastDelete();
  };
  const toggleActiveToastDelete = useCallback(
    () => setActiveDelete((activeDelete) => !activeDelete),
    []
  );

  const handleDeleteAndRefresh = () => {
    setIsSaving(false);
    setTs(+new Date());
    setToastMessage("Section deleted succesfully");
    toggleActiveToast();
  };
  const handleRefreshSections = () => {
    console.log("aaaa");
    setTs(+new Date());
  };

  const [optionsLanguages, setOptionsLanguages] = useState("");
  const [optionsPages, setOptionsPages] = useState("");
  const [optionsMenus, setOptionsMenus] = useState("");
  const [optionsBlogs, setOptionsBlogs] = useState(null);
  const [optionsTemplates, setOptionsTemplates] = useState(null);
  const [result, setResult] = useState("");
  const [resultPreview, setResultPreview] = useState([]);
  const [openStatesArray, setOpenStatesArray] = useState("");
  const [selectedVersion, setSelectedVersion] = useState("");
  // const [versionChanged, setVersionChanged] = useState("");
  const [versionNameValue, setVersionNameValue] = useState("");
  const [errorVersionName, setErrorVersionName] = useState("");
  const handleChangeVersionNameValue = (newValue) => {
    setVersionNameValue(newValue);
    setErrorVersionName("");
  };

  const [activeModalVersion, setActiveModalVersion] = useState(false);
  const handleChangeModalVersion = useCallback(
    () => setActiveModalVersion(!activeModalVersion),
    [activeModalVersion]
  );

  const [allCollectionsOptions, setAllCollectionsOptions] = useState("");
  const [allProductsOptions, setAllProductsOptions] = useState("");
  const [channels, setChannels] = useState([]);
  const [inputValueCollection, setInputValueCollection] = useState("");

  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/pages/${id}/sections/${refDeleteSectionId.current}`)
      .then((result) => {
        setActiveDelete(false);
        handleDeleteAndRefresh();
        setIsOpen(false);
      })
      .catch((err) => console.log(err));
  };
  const [checkedImportSection, setCheckedImportSection] = useState(false);
  const handleChangeImportSection = useCallback(
    (newChecked) => setCheckedImportSection(newChecked),
    []
  );
  const [valueImportType, setValueImportType] = useState("clone");

  const handleChangeImportType = useCallback(
    (_checked, newValue) => setValueImportType(newValue),
    []
  );
  const [openValue, setOpenValue] = useState(false);
  const changeOpenValue = (param) => {
    setOpenValue(param);
  };
  const [isSorting, setIsSorting] = useState(false);
  const loadingMarkup = isSorting ? <Loading /> : null;
  const [title, setTitle] = useState("");
  const [optionsVersions, setOptionsVersions] = useState("");

  const handleCreateVersion = () => {
    if (!versionNameValue) {
      setErrorVersionName("This field is required");
    } else {
      setIsCreatingVersion(true);
      const bodyObj = {
        page_id: id,
        name: versionNameValue,
        current_version_id: parseInt(selectedVersion.value),
      };
      axios
        .post(`/versions`, bodyObj)
        .then((res) => {
          setBoolVersionChanged(true);
          setIsCreatingVersion(false);
          setToastMessage("Version created successfully");
          toggleActiveToast();
          setActiveModalVersion(false);
          setSelectedVersion({
            key: res.data.data,
            label: (
              <div>
                {res.data.data.name}
                <div className={`badgeVersion badgeColorRed`}>Draft</div>
              </div>
            ),
            value: String(res.data.data.id),
          });
          setVersionNameValue("");
          setTs(+new Date());
        })
        .catch((err) => console.log(""));
    }
  };
  const updateOpenArrayStateClose = (param) => {
    console.log("param=", param);
    const newState = openStatesArray.map((obj) => {
      if (obj.id === param) {
        return { ...obj, isOpen: !obj.isOpen };
      }
      return { ...obj, isOpen: false };
      // return obj;
    });

    setOpenStatesArray(newState);
  };
  const updateOpenArrayState = (param) => {
    togglePanel(true);
    setClickedId(param);
    setIsOpeningSlider(true);
    axios
      .get(`pages/${id}/sections/${param}`)
      .then((res) => {
        setClickedElement(JSON.stringify(res.data.data));

        setIsOpeningSlider(false);
      })
      .catch((err) => console.log(""));
    // const newState = openStatesArray.map((obj) => {
    //   if (obj.id === param) {
    //     return { ...obj, isOpen: true };
    //   }
    //   return { ...obj, isOpen: false };
    // });

    // setOpenStatesArray(newState);
    // const element = document.getElementById(`section-${param}`);
    // if (element) {
    //   // 👇 Will scroll smoothly to the top of the next section
    //   element.scrollIntoView({ behavior: "smooth" });
    // }
  };
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = () => {
    setIsExporting(true);

    const bodyObj = {
      entity_type: "section_data",
      page_handle: pageAlias,
    };

    axios
      .post(`/s3/save-file`, bodyObj)
      .then((result) => {
        setIsExporting(false);
        setToastMessage("JSON exported successfully");
        toggleActiveToast();
      })
      .catch(function (error) {});
  };
  const handlePublishVersion = () => {
    setIsPublishing(true);
    axios
      .patch(`/publish/version/${selectedVersion.value}/page/${id}`)
      .then((res) => {
        setToastMessage("Version have been published susccessfully");
        toggleActiveToast();
        setTs(+new Date());
      })
      .catch((err) => console.log(""));
  };

  const [instructionValue, setInstructionValue] = useState("");
  const handleChangeInstruction = useCallback(
    (newValue) => setInstructionValue(newValue),
    []
  );
  let shopifyDomainFound = false;
  const [isShopifyDefined, setIsShopifyDefined] = useState(false);

  //PREVIEW DROPDOWN
  const [activePreviewText, setActivePreviewText] = useState(
    <Icon source={ThemeTemplateIcon} />
  );
  const [activePreview, setActivePreview] = useState(false);
  const toggleActivePreview = useCallback(
    () => setActivePreview((activePreview) => !activePreview),
    []
  );
  const activatorPreview = (
    <Button onClick={toggleActivePreview} disclosure>
      {activePreviewText}
    </Button>
  );
  const [showGeneralInstruction, setShowGeneralInstruction] = useState(false);

  //TOAST MESSAGE
  const [activeToast, setActiveToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const toastMarkup = activeToast ? (
    <Toast content={toastMessage} onDismiss={toggleActiveToast} />
  ) : null;

  //DRAGGING SECTIONS
  const reorder = (list, startIndex, endIndex) => {
    const result2 = Array.from(list);
    const [removed] = result2.splice(startIndex, 1);
    result2.splice(endIndex, 0, removed);
    return result2;
  };
  const equalsCheck = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };
  const onDragEnd = (result2) => {
    // dropped outside the list
    if (!result2.destination) {
      return;
    }
    const reorderedItems = reorder(
      result,
      result2.source.index,
      result2.destination.index
    );
    if (
      !equalsCheck(
        reorderedItems.map((a) => a.id),
        result.map((a) => a.id)
      )
    ) {
      setIsSorting(true);
      setResult(reorderedItems);
      const bodyObj = {
        ids: reorderedItems.map((item) => item.id),
        version_id: parseInt(selectedVersion.value),
      };
      axios
        .post(`/pages/${id}/sections/sorted`, bodyObj)
        .then((res) => {
          setToastMessage("Sections order has been successfully updated");
          toggleActiveToast();
          setIsSorting(false);
          handleRefreshSections();
        })
        .catch((err) => console.log(""));
    }
  };

  useEffect(() => {
    fetchData();
  }, [ts]);
  useEffect(() => {
    fetchShopifyCollections();
  }, [inputValueCollection]);
  async function fetchShopifyCollections() {
    try {
      const responseShopifyDomain = await axios.get(`/settings/shopify`);
      if (responseShopifyDomain?.data?.data?.shopify_domain)
        shopifyDomainFound = true;
      setIsShopifyDefined(
        responseShopifyDomain?.data?.data?.shopify_domain ? 1 : 0
      );
    } catch (error) {
      console.log(error);
    }
    if (shopifyDomainFound) {
      // try {
      //   let responseShopifyCollection = "";
      //   responseShopifyCollection = await axios.get(
      //     selected === "shopify_products_list"
      //       ? `/shopify-products?search=${inputValueCollection}`
      //       : `/shopify-collections?search=${inputValueCollection}`
      //   );
      //   shopifyDomainFound = true;

      //   responseShopifyCollection?.data?.data &&
      //     setOptionsCollections(
      //       responseShopifyCollection.data.data.map((item, index) => {
      //         return {
      //           key: item.id,
      //           label: item.title,
      //           value: item.handle,
      //         };
      //       })
      //     );
      // } catch (error) {
      //   console.log("errorrrr=", error.response.data.message);
      // }
      try {
        let responseShopifyCollection = "";
        responseShopifyCollection = await axios.get(`/shopify-collections`);

        responseShopifyCollection?.data?.data &&
          setAllCollectionsOptions(
            responseShopifyCollection.data.data.map((item, index) => {
              return {
                key: item.id,
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
      } catch (error) {}

      try {
        let responseShopifyProducts = "";
        responseShopifyProducts = await axios.get(`/shopify-products`);

        responseShopifyProducts?.data?.data &&
          setAllProductsOptions(
            responseShopifyProducts.data.data.map((item, index) => {
              return {
                key: item.id,
                label: item.title,
                value: String(item.id),
              };
            })
          );
      } catch (error) {}
    }
  }

  const [pageAlias, setPageAlias] = useState("");
  const [versions, setVersions] = useState("");
  async function fetchData() {
    let responseVersions = "";
    try {
      responseVersions = await axios.get(`/versions?filter[page_id]=${id}`);
      responseVersions?.data?.data?.data &&
        setOptionsVersions(
          responseVersions.data.data.data.map((item, index) => {
            return {
              key: item.id,
              status: item.is_active ? "published" : "draft",
              label: (
                <div>
                  {item.name}
                  <div
                    className={`badgeVersion ${
                      item.is_active ? "badgeColorGreen" : "badgeColorRed"
                    }`}
                  >
                    {item.is_active
                      ? `Published - ${moment(item.updated_at).format(
                          "MM/DD/YYYY"
                        )}`
                      : "Draft"}
                  </div>
                </div>
              ),
              value: String(item.id),
            };
          })
        );
      setVersions(responseVersions);
    } catch (error) {
      console.log(error);
    }

    try {
      const responseSections = await axios.get(
        `/enhanced/pages/${id}/sections?filter[version_id]=${
          selectedVersion === ""
            ? String(findVersion(responseVersions.data.data.data).id)
            : selectedVersion.value
        }`
      );
      responseSections?.data?.data?.instructions &&
        setGeneralInstructionValue(responseSections?.data?.data?.instructions);

      setPageAlias(responseSections?.data?.data?.alias);
      responseSections?.data?.data?.sections?.data?.length
        ? setResult(responseSections.data.data.sections.data)
        : setResult("empty");
      // setIsAutomaticExport(
      //   responseSections?.data?.data?.is_auto_export ? true : false
      // );

      //Set open state for all sections accordion (krmel aarf open and close state la kell lsections accrodion)
      boolVersionChanged &&
        setOpenStatesArray(
          responseSections.data.data.sections.data.map((element) => ({
            id: element.id,
            isOpen: false,
          }))
        );
      // Eza zed new section bde zid open state la ekher accordion nzed
      responseSections?.data?.data?.sections?.data?.length !== result.length &&
        responseSections?.data?.data?.sections?.data?.length &&
        setOpenStatesArray((current) => [
          ...current,
          {
            id: responseSections?.data?.data?.sections?.data[
              responseSections?.data?.data?.sections?.data.length - 1
            ].id,
            isOpen: false,
          },
        ]);
      responseSections?.data?.data?.title &&
        setTitle(responseSections?.data?.data?.title["en"]);
    } catch (error) {
      console.log(error);
    }

    (selectedVersion === "" || isPublishing) &&
      setSelectedVersion({
        key: findVersion(responseVersions.data.data.data).id,
        status: findVersion(responseVersions.data.data.data).is_active
          ? "published"
          : "draft",
        label: (
          <div>
            {findVersion(responseVersions.data.data.data).name}
            <div
              className={`badgeVersion ${
                findVersion(responseVersions.data.data.data).is_active
                  ? "badgeColorGreen"
                  : "badgeColorRed"
              }`}
            >
              {findVersion(responseVersions.data.data.data).is_active
                ? `Published - ${moment(
                    findVersion(responseVersions.data.data.data).updated_at
                  ).format("MM/DD/YYYY")}`
                : "Draft"}
            </div>
          </div>
        ),
        value: String(findVersion(responseVersions.data.data.data).id),
      });
    console.log("optionsLanguages=", optionsLanguages);
    if (!optionsLanguages.length) {
      try {
        const responseLanguages = await axios.get(
          `/settings/languages?filter[is_active]=1`
        );
        responseLanguages?.data?.data?.data &&
          setOptionsLanguages(
            responseLanguages.data.data.data.map((item, index) => {
              return {
                key: index,
                label: item.name,
                value: item.code,
              };
            })
          );
      } catch (error) {
        console.log(error);
      }
    }
    if (!channels.length) {
      try {
        const responseChannels = await axios.get(`/channels`);
        responseChannels?.data?.data?.data &&
          setChannels(
            responseChannels.data.data.data.map((item, index) => {
              return {
                label: item.name,
                value: item.id,
                id: item.id,
              };
            })
          );
      } catch (error) {
        console.log(error);
      }
    }
    if (optionsTemplates === null) {
      try {
        const responseTemplates = await axios.get(`/section-templates`);
        responseTemplates?.data?.data?.data &&
          setOptionsTemplates(responseTemplates?.data?.data?.data);
      } catch (error) {
        console.log(error);
      }
    }
    setLoadingSections(false);
    if (!options.length) {
      let array = [];
      try {
        const responseDisplaySections = await axios.get(
          `/settings/display-content`
        );

        parseInt(responseDisplaySections?.data?.data[1].section?.richtext) &&
          array.push({ label: "Rich Text", value: "rich_text" });
        parseInt(responseDisplaySections?.data?.data[1].section?.banner) &&
          array.push({ label: "Banner", value: "banner" });
        parseInt(responseDisplaySections?.data?.data[1].section?.image) &&
          array.push({ label: "Image with text", value: "image" });
        parseInt(responseDisplaySections?.data?.data[1].section?.list) &&
          array.push({ label: "List", value: "list" });
        parseInt(responseDisplaySections?.data?.data[1].section?.video) &&
          array.push({ label: "Video", value: "video" });
        parseInt(responseDisplaySections?.data?.data[1].section?.code) &&
          array.push({ label: "Code", value: "code" });
        parseInt(responseDisplaySections?.data?.data[1].section?.countdown) &&
          array.push({ label: "Countdown", value: "countdown" });
        parseInt(responseDisplaySections?.data?.data[1].section?.countdown) &&
          array.push({ label: "Popup", value: "popup" });
        parseInt(responseDisplaySections?.data?.data[1].section?.navigation) &&
          array.push({ label: "Navigation", value: "navigation" });
        parseInt(responseDisplaySections?.data?.data[1].section?.navigation) &&
          array.push({ label: "Object", value: "object" });
        parseInt(responseDisplaySections?.data?.data[1].section?.iframe) &&
          array.push({ label: "Iframe", value: "iframe" });
        parseInt(
          responseDisplaySections?.data?.data[1].section?.custom_block
        ) && array.push({ label: "Custom block", value: "custom_block" });
        parseInt(
          responseDisplaySections?.data?.data[1].section?.shopify_collection
        ) &&
          shopifyDomainFound &&
          array.push(
            {
              label: "Shopify Collection",
              value: "shopify_collection",
            },
            {
              label: "List of Shopify Products",
              value: "shopify_products_list",
            }
          );
        setOptions(array);
      } catch (error) {
        if (shopifyDomainFound)
          setOptions([
            { label: "Rich Text", value: "rich_text" },
            { label: "Banner", value: "banner" },
            { label: "Image with text", value: "image" },
            { label: "List", value: "list" },
            { label: "Video", value: "video" },
            { label: "Object", value: "object" },
            { label: "Code", value: "code" },
            { label: "Iframe", value: "iframe" },
            {
              label: "Shopify Collection",
              value: "shopify_collection",
            },
            {
              label: "List of Shopify Products",
              value: "shopify_products_list",
            },
            {
              label: "Countdown",
              value: "countdown",
            },
            {
              label: "Popup",
              value: "popup",
            },
            {
              label: "Navigation",
              value: "navigation",
            },
            {
              label: "Custom block",
              value: "custom_block",
            },

            // { label: "Shopify List of Collections", value: "shopify_collections_list" },
            // { label: "Shopify Product", value: "shopify_products_list",id:8 },
          ]);
        else
          setOptions([
            { label: "Rich Text", value: "rich_text" },
            { label: "Banner", value: "banner" },
            { label: "Image with text", value: "image" },
            { label: "List", value: "list" },
            { label: "Video", value: "video" },
            { label: "Object", value: "object" },
            { label: "Code", value: "code" },
            { label: "Iframe", value: "iframe" },
            {
              label: "Countdown",
              value: "countdown",
            },
            {
              label: "Popup",
              value: "popup",
            },
            {
              label: "Navigation",
              value: "navigation",
            },
            {
              label: "Custom block",
              value: "custom_block",
            },
          ]);
        console.log(error);
      }
    }

    if (!optionsPages.length) {
      try {
        const responsePages = await axios.get(
          `/pages?fields[pages]=id,title,alias&per_page=10000`
        );
        responsePages?.data?.data?.data &&
          setOptionsPages(
            responsePages.data.data.data.map((item, index) => {
              return {
                key: String(item.id),
                label: item.title[Object.keys(item.title)[0]],
                value: item.alias,
              };
            })
          );
      } catch (error) {
        console.log(error);
      }
    }

    if (!optionsMenus.length) {
      try {
        const responseMenus = await axios.get(`/navigation-lists`);
        console.log("responseMenus", responseMenus.data.data.data);
        responseMenus?.data?.data?.data &&
          setOptionsMenus(
            responseMenus.data.data.data.map((item, index) => {
              return {
                key: String(item.id),
                label: item.title,
                value: String(item.id),
              };
            })
          );
      } catch (error) {
        console.log(error);
      }
    }
    if (optionsBlogs === null) {
      try {
        const responseBlogs = await axios.get(
          `/blogs?fields[pages]=id,title,alias`
        );
        responseBlogs?.data?.data?.data &&
          setOptionsBlogs(
            responseBlogs.data.data.data.map((item, index) => {
              return {
                key: String(item.id),
                label: item.title[Object.keys(item.title)[0]],
                value: item.alias,
              };
            })
          );
      } catch (error) {
        console.log(error);
      }
    }

    if (!optionsOtherPagesSections.length) {
      try {
        let array = [];
        const responseSectionsOtherPages = await axios.get(
          `/import/sections/${id}`
        );
        for (
          var i = 0;
          i < responseSectionsOtherPages?.data?.data.length;
          i++
        ) {
          const item = responseSectionsOtherPages?.data?.data[i];
          array.push({
            key: i,
            label: `${item.title["en"].toUpperCase()}`,
            disabled: true,
          });
          for (
            var j = 0;
            j < responseSectionsOtherPages?.data?.data[i].sections.length;
            j++
          ) {
            const sectionItem =
              responseSectionsOtherPages?.data?.data[i].sections[j];
            array.push({
              key: j + "_" + sectionItem.handle,
              label: `${
                sectionItem?.title?.en
                  ? sectionItem?.title?.en
                  : sectionItem.handle
              }`,

              value: String(sectionItem.id),
            });
          }
        }
        setOptionsOtherPagesSections(array);
      } catch (error) {
        console.log(error);
      }
    }

    setBoolVersionChanged(false);
    setIsPublishing(false);

    setIsSaving(false);
  }

  const [
    firstTimeLoadedCollectionsOptions,
    setFirstTimeLoadedCollectionsOptions,
  ] = useState([]);

  const loadOptionsCollections = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: item.handle,
                id: item.id,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: item.handle,
              id: item.id,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  const [shopifyCollection, setShopifyCollection] = useState("");
  const handleSelectChangeShopifyCollection = (value) => {
    console.log(value);
    setShopifyCollection(value);
  };
  const [shopifyError, setShopifyError] = useState("");
  const [isAutomaticExport, setIsAutomaticExport] = useState(false);
  const [clickedId, setClickedId] = useState("");
  const [clickedElement, setClickedElement] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const togglePanel = (param) => {
    setIsOpen(param);
  };
  const [isOpeningSlider, setIsOpeningSlider] = useState(false);
  const handleSectionClick = (param, element) => {
    togglePanel(true);
    setClickedId(param);
    setIsOpeningSlider(true);
    axios
      .get(`pages/${id}/sections/${param}`)
      .then((res) => {
        setClickedElement(JSON.stringify(res.data.data));

        setIsOpeningSlider(false);
      })
      .catch((err) => console.log(""));
  };

  const refreshApi = () => {
    setIsOpeningSlider(true);
    axios
      .get(`pages/${id}/sections/${clickedId}`)
      .then((res) => {
        setIsOpeningSlider(false);
        setClickedElement(JSON.stringify(res.data.data));
      })
      .catch((err) => console.log(""));
  };
  const handleNext = () => {
    // const currentIndex = ids.indexOf(id);
    // if (currentIndex < ids.length - 1) {
    //   setId(ids[currentIndex + 1]);
    // }
  };

  const handlePrevious = () => {
    // const currentIndex = ids.indexOf(id);
    // if (currentIndex > 0) {
    //   setId(ids[currentIndex - 1]);
    // }
  };
  const handleRefresh = () => {
    setTs(+new Date());
  };
  return (
    <Page
      title={title ? `${title} Sections` : ""}
      backAction={{
        onAction: () => navigate(`/admin/${props.type}`),
      }}
      primaryAction={
        <ButtonGroup>
          {/* <FormControlLabel
            control={
              <Switch
                checked={isAutomaticExport}
                onChange={() => {
                  setIsAutomaticExport(!isAutomaticExport);
                  const bodyObj = {
                    is_auto_export: !isAutomaticExport === true ? 1 : 0,
                    page_handle: pageAlias,
                  };

                  axios
                    .post(`/page-sections/toggle-export`, bodyObj)
                    .then((result) => {})
                    .catch(function (error) {});
                }}
              />
            }
            label="Automatic Export"
            labelPlacement="end"
          /> */}
          <Button
            variant="primary"
            onClick={handleAddSection}
            disabled={!accessAddSections()}
          >
            Add Section
          </Button>
        </ButtonGroup>
      }
      // fullWidth={previewState === "tablet-preview"}
      titleMetadata={
        generalInstructionValue ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setShowGeneralInstruction(!showGeneralInstruction)}
          >
            <Icon source={AlertCircleIcon} color="subdued" />
          </div>
        ) : (
          ""
        )
      }
    >
      {loadingMarkup}
      {generalInstructionValue && showGeneralInstruction && (
        <div>
          <Banner title="Instructions:">
            {generalInstructionValue ? parse(generalInstructionValue) : ""}
          </Banner>
        </div>
      )}
      <FormLayout>
        {/* <h1>{JSON.stringify(clickedElement)}</h1> */}
        {result ? (
          <InlineGrid columns={["twoThirds", "oneThird"]} gap="200">
            <div className="rowDiv">
              <div style={{ width: "70%" }}>
                <SelectCustom
                  // defaultValue={selectedVersion}
                  value={selectedVersion}
                  onChange={(newValue) => {
                    console.log("newValue=", newValue);
                    setSelectedVersion(newValue);
                    // setVersionChanged(newValue);
                    setLoadingSections(true);
                    setTs(+new Date());
                    setBoolVersionChanged(true);
                  }}
                  options={optionsVersions}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      backgroundColor: "white",
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (
                      styles,
                      { data, isDisabled, isFocused, isSelected }
                    ) => {
                      return {
                        ...styles,

                        cursor: "pointer",
                      };
                    },
                  }}
                />
              </div>
              <div className="ms-3">
                <Button
                  outline
                  onClick={() => setActiveModalVersion(true)}
                  disabled={!accessCloneVersion()}
                >
                  Clone
                </Button>
              </div>
            </div>

            <div style={{ float: "right" }}>
              <ButtonGroup>
                <Button
                  outline
                  onClick={handleExport}
                  loading={isExporting}
                  icon={ExportIcon}
                >
                  Export
                </Button>
                <Button
                  outline
                  onClick={handlePublishVersion}
                  loading={isPublishing}
                  icon={OutgoingIcon}
                  disabled={
                    selectedVersion.status === "published" ||
                    !accessPublishVersion()
                  }
                >
                  Publish
                </Button>
              </ButtonGroup>
            </div>
          </InlineGrid>
        ) : null}
        {boolPreview && result !== "empty" && (
          <div
            className="d-flex flex-row float-right"
            style={{ justifyContent: "right" }}
          >
            <Popover
              active={activePreview}
              activator={activatorPreview}
              autofocusTarget="first-node"
              onClose={toggleActivePreview}
            >
              <ActionList
                actionRole="menuitem"
                items={[
                  {
                    content: "No Preview",
                    icon: ThemeTemplateIcon,
                    onAction: () => {
                      setActivePreviewText(<Icon source={ThemeTemplateIcon} />);
                      setActivePreview(false);
                      setPreviewState("nothing-preview");
                    },
                  },
                  // {
                  //   content: "Inline Preview",
                  //   icon: TextWithImageIcon,
                  //   onAction: () => {
                  //     setActivePreviewText(
                  //       <Icon source={TextWithImageIcon} />
                  //     );
                  //     setActivePreview(false);
                  //     setPreviewState("inline-preview");
                  //   },
                  // },
                  {
                    content: "Mobile Preview",
                    icon: MobileIcon,
                    onAction: () => {
                      setActivePreviewText(<Icon source={MobileIcon} />);
                      setActivePreview(false);
                      setPreviewState("tablet-preview");
                      axios
                        .get(
                          `pages/${id}/sections?filter[version_id]=${
                            selectedVersion === ""
                              ? String(findVersion(versions.data.data.data).id)
                              : selectedVersion.value
                          }`
                        )
                        .then((result) => {
                          console.log("sbc==", result.data.data.sections.data);
                          setResultPreview(result.data.data.sections.data);
                        })
                        .catch(function (error) {});
                    },
                  },
                ]}
              />
            </Popover>
          </div>
        )}
        <InlineGrid
          columns={
            previewState === "tablet-preview"
              ? ["twoThirds", "oneThird"]
              : ["1fr"]
          }
          gap="200"
        >
          {result === "empty" ? (
            <Card sectioned>
              <Text variant="headingMd" as="h6">
                No Sections Found
              </Text>
            </Card>
          ) : result && openStatesArray && result.length && !loadingSections ? (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId={"droppable"}>
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    // style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {result.map((element, idx) => {
                      return (
                        <Draggable
                          key={element.id}
                          draggableId={String(element.id)}
                          index={idx}

                          // isDragDisabled={openValue ? true : false}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              onClick={() =>
                                handleSectionClick(
                                  element.id,
                                  JSON.stringify(element)
                                )
                              }
                              // draggable={false}
                              // style={{ cursor: "default" }}

                              // style={getItemStyle(
                              //   snapshot.isDragging,
                              //   provided.draggableProps.style
                              // )}
                            >
                              <SectionCollapseOutside
                                id={`section-${element.id}`}
                                updateOpenArrayStateClose={
                                  updateOpenArrayStateClose
                                }
                                openState={false}
                                // openState={
                                //   openStatesArray &&
                                //   findElementByID(openStatesArray, element.id)
                                //     ? findElementByID(
                                //         openStatesArray,
                                //         element.id
                                //       ).isOpen
                                //     : false
                                // }
                                previewState={previewState}
                                dragHandleProps={{
                                  ...provided.dragHandleProps,
                                }}
                                key={idx}
                                type={element.section_type}
                                title={`Section ${idx + 1}`}
                                object={JSON.stringify(element)}
                                languagesArray={
                                  optionsLanguages ? optionsLanguages : []
                                }
                                pagesArray={optionsPages ? optionsPages : []}
                                blogsArray={optionsBlogs ? optionsBlogs : []}
                                menusArray={optionsMenus ? optionsMenus : []}
                                sectionId={element.id}
                                lastElememtId={result[result.length - 1].id}
                                handleSaveAndRefresh={handleSaveAndRefresh}
                                handleSaveWithoutRefresh={
                                  handleSaveWithoutRefresh
                                }
                                isSaving={isSaving}
                                handleSavingState={handleSavingState}
                                handleDeleteAndRefresh={handleDeleteAndRefresh}
                                handleRefreshSections={handleRefreshSections}
                                changeOpenValue={changeOpenValue}
                                urlType={props.type}
                                handleResetSavingState={handleResetSavingState}
                                handleShowDeleteModal={handleShowDeleteModal}
                                collectionsArray={
                                  allCollectionsOptions
                                    ? allCollectionsOptions
                                    : []
                                }
                                productsArray={
                                  allProductsOptions ? allProductsOptions : []
                                }
                                channels={channels ? channels : []}
                                templates={
                                  optionsTemplates ? optionsTemplates : []
                                }
                                shopifyDomainFound={isShopifyDefined}
                              />
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          ) : (
            <div className="spinnerContainer">
              <div className="vertical-center">
                <Spinner size="large" />
              </div>
            </div>
          )}

          {previewState === "tablet-preview" && (
            <div className="tablet">
              <div className="content">
                {result && result.length && (
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId={"droppable"}>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          // style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {resultPreview && resultPreview.length ? (
                            resultPreview.map((element, idx) => (
                              <Draggable
                                key={element.id}
                                draggableId={String(element.id)}
                                index={idx}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    {element.section_type === "rich_text" && (
                                      <RichTextPreview
                                        sectionId={element.id}
                                        updateOpenArrayState={
                                          updateOpenArrayState
                                        }
                                        title={
                                          element.title && element.title.en
                                            ? element.title.en
                                            : ""
                                        }
                                        text={
                                          element.details &&
                                          element.details.text &&
                                          element.details.text.en
                                            ? element.details.text.en
                                            : ""
                                        }
                                      />
                                    )}

                                    {/* a */}
                                    {element.section_type === "banner" && (
                                      <BannerPreview
                                        sectionId={element.id}
                                        updateOpenArrayState={
                                          updateOpenArrayState
                                        }
                                        image={
                                          element.details &&
                                          (element.details.image &&
                                          element.details.image.en
                                            ? element.details.image.en
                                            : element.details.mobile_image &&
                                              element.details.mobile_image.en
                                            ? element.details.mobile_image.en
                                            : "")
                                        }
                                        title={
                                          element.title && element.title.en
                                            ? element.title.en
                                            : ""
                                        }
                                        subtitle={
                                          element.title && element.subtitle.en
                                            ? element.subtitle.en
                                            : ""
                                        }
                                      />
                                    )}

                                    {element.section_type === "video" && (
                                      <VideoPreview
                                        sectionId={element.id}
                                        updateOpenArrayState={
                                          updateOpenArrayState
                                        }
                                        image={
                                          element.details &&
                                          element.details.thumbnail
                                            ? element.details.thumbnail.en
                                            : ""
                                        }
                                      />
                                    )}
                                    {element.section_type === "list" && (
                                      <ListPreview
                                        sectionId={element.id}
                                        updateOpenArrayState={
                                          updateOpenArrayState
                                        }
                                        list={
                                          element.details &&
                                          element.details.list
                                            ? element.details.list
                                            : []
                                        }
                                        template={element?.template_description}
                                        title={element?.title?.en}
                                      />
                                      // <ListPreview
                                      //   sectionId={element.id}
                                      //   updateOpenArrayState={
                                      //     updateOpenArrayState
                                      //   }
                                      //   list={
                                      //     element.details &&
                                      //     element.details.list
                                      //       ? element.details.list
                                      //       : []
                                      //   }
                                      // />
                                    )}
                                    {element.section_type ===
                                      "shopify_collection" &&
                                    element.details.products &&
                                    element.details.products.length ? (
                                      <ShopifyCollectionPreviewSlider
                                        sectionId={element.id}
                                        updateOpenArrayState={
                                          updateOpenArrayState
                                        }
                                        list={
                                          element.details &&
                                          element.details.products
                                            ? element.details.products
                                            : []
                                        }
                                        title={
                                          element?.title?.en
                                            ? element?.title?.en
                                            : ""
                                        }
                                        template={element?.template_description}
                                        image={
                                          element.details &&
                                          element.details.image &&
                                          element.details.image.en
                                            ? element.details.image.en
                                            : ""
                                        }
                                      />
                                    ) : // <ShopifyCollectionPreview
                                    //   sectionId={element.id}
                                    //   updateOpenArrayState={
                                    //     updateOpenArrayState
                                    //   }
                                    //   list={
                                    //     element.details &&
                                    //     element.details.products
                                    //       ? element.details.products
                                    //       : []
                                    //   }
                                    // />
                                    null}
                                    {element.section_type ===
                                      "shopify_products_list" && (
                                      <ShopifyProductsPreview
                                        sectionId={element.id}
                                        updateOpenArrayState={
                                          updateOpenArrayState
                                        }
                                        list={
                                          element.details &&
                                          element.details.list
                                            ? element.details.list
                                            : []
                                        }
                                      />
                                      // <ShopifyCollectionPreview
                                      //   sectionId={element.id}
                                      //   updateOpenArrayState={
                                      //     updateOpenArrayState
                                      //   }
                                      //   list={
                                      //     element.details &&
                                      //     element.details.products
                                      //       ? element.details.products
                                      //       : []
                                      //   }
                                      // />
                                    )}
                                    {element.section_type === "image" && (
                                      <ImageWithTextPreview
                                        sectionId={element.id}
                                        updateOpenArrayState={
                                          updateOpenArrayState
                                        }
                                        image={
                                          element.details &&
                                          element.details.image &&
                                          element.details.image.en
                                            ? element.details.image.en
                                            : ""
                                        }
                                        title={
                                          element.title && element.title.en
                                            ? element.title.en
                                            : ""
                                        }
                                        text={
                                          element.details &&
                                          element.details.text &&
                                          element.details.text.en
                                            ? element.details.text.en
                                            : ""
                                        }
                                      />
                                    )}
                                  </div>
                                )}
                              </Draggable>
                            ))
                          ) : (
                            <Spinner />
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                )}
              </div>
            </div>
          )}
        </InlineGrid>
      </FormLayout>
      {isOpen && (
        <SlidingPanel
          isOpeningSlider={isOpeningSlider}
          title=""
          isOpen={isOpen}
          togglePanel={togglePanel}
          id={clickedId}
          openState={true}
          handleRefresh={handleRefresh}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          type={parse(clickedElement).section_type}
          object={clickedElement}
          languagesArray={optionsLanguages ? optionsLanguages : []}
          pagesArray={optionsPages ? optionsPages : []}
          blogsArray={optionsBlogs ? optionsBlogs : []}
          menusArray={optionsMenus ? optionsMenus : []}
          sectionId={clickedId}
          //lastElememtId={result[result.length - 1].id}
          handleSaveAndRefresh={handleSaveAndRefresh}
          handleSaveWithoutRefresh={handleSaveWithoutRefresh}
          isSaving={isSaving}
          handleSavingState={handleSavingState}
          handleDeleteAndRefresh={handleDeleteAndRefresh}
          handleRefreshSections={handleRefreshSections}
          changeOpenValue={changeOpenValue}
          urlType={props.type}
          handleResetSavingState={handleResetSavingState}
          handleShowDeleteModal={handleShowDeleteModal}
          collectionsArray={allCollectionsOptions ? allCollectionsOptions : []}
          productsArray={allProductsOptions ? allProductsOptions : []}
          channels={channels ? channels : []}
          templates={optionsTemplates ? optionsTemplates : []}
          shopifyDomainFound={isShopifyDefined}
          refreshApi={refreshApi}
        />
      )}
      <Modal
        open={active}
        onClose={handleChange}
        title="Add Section"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChange,
            loading: isSaving,
          },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <Checkbox
              label="Import Section"
              checked={checkedImportSection}
              onChange={handleChangeImportSection}
            />
            {checkedImportSection && (
              <InlineStack gap="200" align="start" blockAlign="center">
                <RadioButton
                  label="Clone"
                  helpText="When you change in the section, the original also changes"
                  checked={valueImportType === "clone"}
                  id="clone"
                  onChange={handleChangeImportType}
                />
                <RadioButton
                  label="Copy"
                  helpText="When you change in the section, the original does not change"
                  id="copy"
                  checked={valueImportType === "copy"}
                  onChange={handleChangeImportType}
                />
              </InlineStack>
            )}
            {!checkedImportSection ? (
              <div style={{ marginTop: "2rem" }}>
                <FormLayout>
                  <Text variant="headingSm" as="h6">
                    Section Type
                  </Text>
                  <Select
                    options={options}
                    onChange={handleSelectChange}
                    value={selected}
                    placeholder="Please select"
                    error={sectionTypeError}
                  />
                  {selected === "shopify_collection" && (
                    <div className="mt-3">
                      <AsyncSelect
                        cacheOptions
                        defaultOptions={firstTimeLoadedCollectionsOptions}
                        loadOptions={loadOptionsCollections}
                        onChange={handleSelectChangeShopifyCollection}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        value={shopifyCollection}
                      />

                      {/* <Autocomplete
                        options={optionsCollections}
                        selected={selectedOptions}
                        onSelect={updateSelection}
                        textField={textField}
                      /> */}
                      <InlineError message={shopifyError} />
                    </div>
                  )}
                  {selected && (
                    <TextField
                      label="Instruction"
                      value={instructionValue}
                      onChange={handleChangeInstruction}
                    />
                  )}
                </FormLayout>
              </div>
            ) : (
              <div style={{ marginTop: "2rem" }}>
                <FormLayout>
                  <Text variant="headingSm" as="h6">
                    Choose a section to import
                  </Text>
                  <Select
                    options={optionsOtherPagesSections}
                    onChange={handleSelectChangeOtherPagesSection}
                    value={selectedOtherPagesSection}
                    placeholder="Please select"
                    error={otherPagesSectionError}
                  />
                </FormLayout>
              </div>
            )}
          </FormLayout>
        </Modal.Section>
      </Modal>

      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Section"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this section?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalVersion}
        onClose={handleChangeModalVersion}
        title="Clone Version"
        primaryAction={{
          content: "Submit",
          onAction: handleCreateVersion,
          loading: isCreatingVersion,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChangeModalVersion,
            loading: isCreatingVersion,
          },
        ]}
      >
        <Card sectioned>
          <TextField
            label="Version Name"
            value={versionNameValue}
            onChange={handleChangeVersionNameValue}
            error={errorVersionName}
          />
        </Card>
      </Modal>

      {toastMarkup}
    </Page>
  );
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
  function findVersion(array) {
    return array.find((element) => {
      return element.is_active === 1;
    });
  }
};

export default Sections;
